import { render } from "./Autocomplete.vue?vue&type=template&id=22e89a86"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"

import "./Autocomplete.vue?vue&type=style&index=0&id=22e89a86&lang=css"
script.render = render

export default script